import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./Accordion.module.scss";

const Accordion = ({
  head, body, className, isOpenByDefault = false, children
}) => {
  return (
    <details className={classNames(styles["accordion"], className)} open={isOpenByDefault}>
      <summary>{head}</summary>
      {body ?? children}
    </details>
  );
};

Accordion.propTypes = {
  head: PropTypes.node,
  body: PropTypes.node,
  className: PropTypes.string,
  isOpenByDefault: PropTypes.bool,
};

export default Accordion;
